/**
 * Liquid cooling list column width tokens — equal flex per rack table design (#1154).
 */

import {
  repeatableColumnCellStyle,
  repeatableColumnHorizontalPadding,
  repeatableCompactColumnLayoutForTests,
  repeatableDesktopColumnLayoutForTests,
} from '../repeatableSections/repeatableTableColumnLayout';

import type {
  LiquidCoolingCduTableColumnKey,
  LiquidCoolingCduTableLayout,
} from './liquidCoolingCduListUtils';

export function liquidCoolingCduColumnHorizontalPadding(
  column: LiquidCoolingCduTableColumnKey,
  layoutMode: LiquidCoolingCduTableLayout,
): number {
  return repeatableColumnHorizontalPadding(column, layoutMode);
}

export function liquidCoolingCduColumnCellStyle(
  column: LiquidCoolingCduTableColumnKey,
  layoutMode: LiquidCoolingCduTableLayout,
): Record<string, unknown> {
  const paddingHorizontal = liquidCoolingCduColumnHorizontalPadding(
    column,
    layoutMode,
  );
  // Desktop: keep STATUS compact. Compact/mobile: equal flex with other columns.
  if (column === 'STATUS' && layoutMode !== 'compact') {
    return {
      flex: 0,
      flexGrow: 0,
      flexShrink: 0,
      width: 84,
      minWidth: 84,
      paddingHorizontal,
    };
  }
  return repeatableColumnCellStyle(column, layoutMode);
}

/** @internal — unit tests assert equal flex layout. */
export const desktopColumnLayoutForTests =
  repeatableDesktopColumnLayoutForTests;

/** @internal — unit tests assert equal flex layout. */
export const compactColumnLayoutForTests =
  repeatableCompactColumnLayoutForTests;
